<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <th></th>
                    <sortable-header @sort="handleSort" sort-by="id" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap">Item #</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="title" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2" colspan="4">Product</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="shorted_quantity" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Shorted (Total)</sortable-header>
                </tr>
            </thead>
            <tbody>
                <template v-for="(product, index) in data" :key="product.id">
                    <tr
                        :class="[
                            'shorts-parent-row border-t border-b border-gray-200 cursor-pointer',
                            index % 2 === 0 ? 'shorts-row-even' : 'shorts-row-odd'
                        ]"
                        @click="toggleShortDetails(product.id)"
                    >
                        <td @click.stop="toggleShortDetails(product.id)">
                            <i :class="shortDetails[product.id] ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
                            class="cursor-pointer" />
                        </td>
                        <td>{{ product.id }}</td>
                        <td colspan="4">
                            {{ product.title }}
                            <span v-if="product.description"> - {{ product.description }}</span>
                            <span v-if="product.size"> - {{ product.size }}</span>
                        </td>
                        <td class="text-right shorts-last-col">
                            {{ product.shorted_quantity }}
                        </td>
                    </tr>

                    <!-- Expand rows -->
                    <template v-if="shortDetails[product.id]">
                        <tr :class="['text-xs uppercase tracking-wide text-gray-600', index % 2 === 0 ? 'shorts-row-even' : 'shorts-row-odd']">
                            <td></td>
                            <td></td>
                            <td class="font-bold">Order #</td>
                            <td class="font-bold">Picker</td>
                            <td class="font-bold">Checker</td>
                            <td class="font-bold">Approver</td>
                            <td class="font-bold shorts-last-col">Shorted</td>
                        </tr>
                        <tr
                            v-for="data in shortDetails[product.id]"
                            :key="data.id"
                            :class="index % 2 === 0 ? 'shorts-row-even' : 'shorts-row-odd'"
                        >
                            <td></td>
                            <td></td>
                            <td @click="openInNewTab(`/orders/${data.order_id}`)" class="cursor-pointer">
                                {{ data.order_number }}
                            </td>
                            <td>{{ data.picker }}</td>
                            <td>{{ data.checker }}</td>
                            <td>{{ data.approver || 'System' }}</td>
                            <td class="font-medium shorts-last-col">{{ parseFloat(data.diff_quantity).toString() }}</td>
                        </tr>
                    </template>
                </template>
            </tbody>
            <tfoot>
                <tr>
                    <td class=""></td>
                    <td class=""></td>
                    <td colspan="4" class="text-left">Total:</td>
                    <td class="text-right shorts-last-col">{{ totalTotal }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import SortableHeader from '@/Shared/SortableHeader';
import axios from 'axios';
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        SortableHeader,Link
    },

    props: ['data', 'sort_column', 'sort_direction', 'filters'],
    emits: ['sort'],

    data(){
        return {
            shortDetails : {}
        }
    },

    methods: {
        handleSort (sort) {
            this.$emit('sort', sort);
        },

        openInNewTab(url) {
            window.open(url, '_blank');
        },

        toggleShortDetails(product_id){
            if (this.shortDetails[product_id]){
                delete this.shortDetails[product_id];
                return;
            }

            axios.get(`/reports/shorts/${product_id}`, {
                params: {
                    filters: this.filters
                }
            })
            .then(response=>{
                this.shortDetails[product_id] = response.data;
            })
            .catch(error => {
                console.error(error);
            });

        },

        parseProductData (product) {
            let orderIdArray = product.order_ids.split(",");
            let checkerArray = product.checker_names.split(",");
            let approverArray = product.approver_names.split(",");

            return orderIdArray.map((id, index) => ({
                orderId: id,
                checker: checkerArray[index],
                approver: approverArray[index]
            }));
        }
    },

    computed: {
        totalTotal() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.shorted_quantity);
            }, 0);
        },
    }

}
</script>

<style scoped>
    .shorts-row-even {
        background-color: #F9F9F9 !important;
    }

    .shorts-row-odd {
        background-color: white !important;
    }

    .shorts-last-col {
        padding-right: 2.25rem;
    }

    .bg-logo {
        background: #efefef;
    }

    .brand {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .brand img {
        max-height: 38px;
    }

    .brand a {
        line-height: 1;
        font-size: 14px;
    }
</style>